import React from 'react';

import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';

import { VerifierType } from 'src/api';
import { FontWeight } from 'src/theme';

interface DashboardVerifierTypeSelectProps {
  verifierType: VerifierType;
  setVerifierType: React.Dispatch<React.SetStateAction<VerifierType>>;
}

export const DashboardVerifierTypeSelect: React.FC<DashboardVerifierTypeSelectProps> = ({
  verifierType,
  setVerifierType,
}) => {
  const anchorEl = React.useRef<HTMLElement | null>(null);

  const [isOpen, setIsOpen] = React.useState(false);
  const handleToggle = React.useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleSelected = React.useCallback(
    (verifierType: VerifierType) => {
      setVerifierType(verifierType);
      setIsOpen(false);
    },
    [setVerifierType],
  );

  const menuItems = React.useMemo(() => {
    return [VerifierType.Commercial, VerifierType.Government].filter(item => item !== verifierType);
  }, [verifierType]);

  return (
    <Box display="flex" flexDirection="column" alignItems="stretch">
      <Box
        ref={anchorEl}
        onClick={handleToggle}
        display="flex"
        flexDirection="row"
        alignItems="center"
        fontWeight={FontWeight.SemiBold}
      >
        {verifierType}
        <IconButton>
          <ArrowDropDownIcon fontSize="small" />
        </IconButton>
      </Box>

      <Menu anchorEl={anchorEl.current} open={isOpen} onClose={handleToggle} sx={{ mt: 1 }}>
        {menuItems.map(item => (
          <MenuItem key={item} onClick={() => handleSelected(item)}>
            <Typography variant="body1">{item}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
